import { httpApi } from './http.api';
import { Pagination } from './table.api';
import { Priority } from '@app/constants/enums/priorities';
import { Order, SummaryOrder } from '@app/types/generalTypes';

interface Status {
  code: number;
  value: string;
  priority: Priority;
}

export interface OrdersTableEntry {
  key: string;
  fullName: string;
  mobile: string;
  address?: string;
  date: number;
  status: Status;
  totalPrice: number;
}

interface OrdersTableData {
  data: OrdersTableEntry[];
  pagination: Pagination;
}

interface Meta {
  total: number;
  skip: number;
  limit: number;
  fullName: string;
  status: number;
  mobile: string;
  more: boolean;
}

interface OrdersResponse {
  message: string;
  data: {
    orders: SummaryOrder[];
    meta: Meta;
  };
}

interface OrderResponse {
  message: string;
  data: Order;
}

export const getOrdersTableData = async (pagination: Pagination): Promise<OrdersTableData> => {
  const page = ((pagination?.current ?? 1) - 1) * (pagination.pageSize ?? 25);
  const priorityObj = [Priority.INFO, Priority.MEDIUM, Priority.LOW, Priority.HIGH, Priority.LOW];

  try {
    const res = await httpApi.get<OrdersResponse>(`/order?skip=${page}&limit=${pagination.pageSize}`);
    const data = res.data.data;
    const orders: OrdersTableEntry[] = data.orders.map((order) => ({
      key: order.id,
      fullName: order.user.fullName,
      mobile: order.user.mobile,
      address: order.address ? `${order.address.city} - ${order.address.province} - ${order.address.address}` : '',
      date: new Date(order.createdAt).getTime(),
      status: {
        code: order.address ? order.status : 4,
        value: order.address ? order.statusTitle : 'انجام شده',
        priority: priorityObj[order.address ? order.status : 4],
      },
      totalPrice: order.totalPrice,
    }));

    return { data: orders, pagination: { ...pagination, total: data.meta.total } };
  } catch (error) {
    console.log(error);
    return { data: [], pagination: { ...pagination, total: 0 } };
  }
};

export const getOrderData = async (id: string): Promise<Order> => {
  try {
    const res = await httpApi.get<OrderResponse>(`/order/${id}`);
    const data = res.data.data;
    return data;
  } catch (error) {
    return Promise.reject('Failed to fetch order');
  }
};

export const UpdateOrderData = async (id: string, data: { status?: number; postTrack?: string }): Promise<Order> => {
  try {
    const res = await httpApi.patch<OrderResponse>(`/order/${id}`, data);
    const updatedOrder = res.data.data;
    return updatedOrder;
  } catch (error) {
    return Promise.reject('Failed to update order');
  }
};
